<template>    
    <DataTable v-if='rates && !loadingRates' :value="rates" responsiveLayout="scroll" ref="dt" dataKey="id" class="w-full"
        :rows="200" :rowsPerPageOptions="[5, 10, 20, 50, 100]" :totalRecords="totalRecords"
        @page="onPage($event)" @sort="onSort($event)" :loading="loadingRates" 
        @filter="onFilter($event)" v-model:filters="filters" filterDisplay="menu" :globalFilterFields="['type', 'stock_type', 'from_currency_code', 'to_currency_code']" >

        <Column field="from_currency_code" header="" :showFilterMenu="true" :showFilterMatchModes="false">
            <template #header>
                <span class="text-xs">From</span>
            </template>
            <template #filter="{ filterModel, filterCallback }">
                <Dropdown v-model="filterModel.value" @change="filterCallback()" :options="currenciesCodes" placeholder="Все" class="p-column-filter" :showClear="true" filter>
                    <template #option="slotProps">
                        <div class="inline-block py-1 px-2 text-xs border-round-md font-semibold surface-300 cursor-pointer font-medium align-items-center" >
                            <span class="flex">{{slotProps.option.toUpperCase()}}</span>
                        </div>
                    </template>
                </Dropdown>
            </template>
            <template #body="{ data }">
                <div class="flex flex-row align-items-center gap-2" >
                    <AvatarGroup v-if="data.from_currency_code">
                        <Avatar :image="getCurImage(data.from_currency_code)" class="surface-0 border-1 border-100" shape="circle"/>
                    </AvatarGroup>
                    <p class="text-xs white-space-nowrap m-0">
                        {{ (data.from_currency_code) ? data.from_currency_code.toString().toUpperCase() : '–'}}
                    </p>
                </div>
            </template>
        </Column>

        <Column field="to_currency_code" header="" :showFilterMenu="true" :showFilterMatchModes="false">
            <template #header>
                <span class="text-xs">To</span>
            </template>
            <template #filter="{ filterModel, filterCallback }">
                <Dropdown v-model="filterModel.value" @change="filterCallback()" :options="currenciesCodes" placeholder="Все" class="p-column-filter" :showClear="true" filter>
                    <template #option="slotProps">
                        <div class="inline-block py-1 px-2 text-xs border-round-md font-semibold surface-300 cursor-pointer font-medium align-items-center" >
                            <span class="flex">{{slotProps.option.toUpperCase()}}</span>
                        </div>
                    </template>
                </Dropdown>
            </template>
            <template #body="{ data }">
                <div class="flex flex-row align-items-center gap-2" >
                    <AvatarGroup v-if="data.to_currency_code">
                        <Avatar :image="getCurImage(data.to_currency_code)" class="surface-0 border-1 border-100" shape="circle"/>
                    </AvatarGroup>
                    <p class="text-xs white-space-nowrap m-0">
                        {{ (data.to_currency_code) ? data.to_currency_code.toString().toUpperCase() : '–'}}
                    </p>
                </div>
            </template>
        </Column>
        <Column field="rate_">
            <template #header>
                <span class="text-xs">Обменный курс</span>
            </template>
            <template #body="{ data }">
                <div class="flex flex-row align-items-center gap-3" >
                    <p class="text-xs white-space-nowrap m-0">
                        <span class="font-medium">{{ getExchangeRate(data)}}</span> <br>
                        <span v-if="getReverceRate(getExchangeRate(data))">{{ getReverceRate(getExchangeRate(data))}}</span>
                    </p>
                </div>
            </template>
        </Column>
        <Column field="percents">
            <template #header>
                <span class="text-xs">Комиссии от % (прм/выпл)</span>
            </template>
            <template #body="{ data }">
                <div class="flex flex-row align-items-center gap-3" >
                    <div class="flex flex-column gap-1">
                        <small class="flex text-xs white-space-nowrap m-0">
                            Перевод: {{ getFormatCom(data, 'transfer', 'get') }} /
                            {{ getFormatCom(data, 'transfer', 'send') }} /
                            {{ getFormatCom(data, 'transfer', 'service') }}
                        </small>
                        <small v-if="data.type=='origin' && data.to_currency_code=='usdt'" 
                            class="flex text-xs white-space-nowrap m-0">
                            Пополнение: {{ getFormatCom(data, 'topup', 'get') }} /
                            {{ getFormatCom(data, 'topup', 'send') }}
                        </small>
                        <small v-if="data.type=='origin' && data.from_currency_code=='usdt'" 
                            class="flex text-xs white-space-nowrap m-0">
                            Вывод: {{ getFormatCom(data, 'withdraw', 'get') }} /
                            {{ getFormatCom(data, 'withdraw', 'send') }}
                        </small>
                        <small class="flex text-xs white-space-nowrap m-0">
                            Счет: {{ getFormatCom(data, 'bill', 'get') }} /
                            {{ getFormatCom(data, 'bill', 'send') }} /
                            {{ getFormatCom(data, 'bill', 'service') }}
                        </small>
                    </div>
                </div>
            </template>
        </Column>

    </DataTable>

    <div class="flex flex-column align-items-center justify-content-center mt-3 px-2">
        <Skeleton height="2rem" v-if="loadingRates" />
    </div>

</template>

<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import BigNumber from 'bignumber.js'
import { CurrencyList } from '@/assets/js/classes/Currency.js'

export default {
    data() {
        return {
            rates: null,
            loadingRates: false,
            selectedColumns: [],
            lazyParams: {},
            currencies: [],
            currenciesCodes: [],
            filters: {
                type: {value: '', matchMode: 'contains'},
                stock_type: {
                    type: {value: '', matchMode: 'contains'},
                },
                from_currency_code: {value: '', matchMode: 'contains'},
                to_currency_code: {value: '', matchMode: 'contains'},
            },
        }
    },
    computed: {
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
    },
    methods: {
        onPage(event) {
            this.lazyParams = event
        },
        onSort(event) {
            this.lazyParams = event
        },
        onFilter() {
            this.lazyParams.filters = this.filters
        },
        onRowSelect() {
            this.selectAll = this.selectedCustomers.length === this.totalRecords
        },
        onRowUnselect() {
            this.selectAll = false;
        },
        getReverceRate(rate){
            return this.helper.get_reverce_rate(rate)
        },
        getCurImage(code){
            return this.helper.GetCurrencyImage(code, this.currencies)
        },
        showMess(severity, summary, detail) {
            this.$toast.add({severity: severity, summary: summary, detail: detail, life: 3000});
        },
        getExchangeRate(obj) {
            if(!obj) return 0
            if(!obj.type) return 0
            switch(obj.type){
                case 'origin':
                    return (obj.rate) ? obj.rate : 0;
                case 'nulled':
                    return '';
                case 'calculated':
                    let left_rate = this.rates.find(item => {
                        return item.from_currency_code == obj.from_currency_code && item.type == 'origin'
                    })
                    let right_rate = this.rates.find(item => {
                        return item.to_currency_code == obj.to_currency_code && item.type == 'origin'
                    })
                    if(left_rate && right_rate){
                        let b_left = new BigNumber(left_rate.rate)
                        let b_right = new BigNumber(right_rate.rate)
                        let recalc_rate = b_right.multipliedBy(b_left)
                        return recalc_rate.toFixed(9) // точность 3 знака после запятой
                    } else return 'не найден origin курс'
                default:
                    return 'неизвестный тип курса';
            }
        },
        async LoadRates(){
            this.loadingRates = true
            this.rates = []
            try {
                const rates = await this.connect.GetRatesForMerchant().then(res => res)
                if (rates.result) {
                    for (const [k, v] of Object.entries(rates.data)) {
                        if(!v.type || (v.type != 'calculated' && v.type != 'origin') || !v.active) continue
                        this.rates.push(v)
                    }
                }
                else{
                    this.showMess('error', 'Ошибка', 'Не удалось загрузить курсы')
                    this.rates = []
                }
            } catch (error) {
                console.log('error', error)
                this.showMess('error', 'Ошибка', 'Не удалось загрузить курсы')
                this.rates = []
            }
            this.loadingRates = false
        },
        async LoadCurrencies(){
            this.currencies = await CurrencyList.GetList(this.$store).then(r=>r)
            this.currenciesCodes = this.currencies.map(c=>c.code)
        },
        getFormatPercent(percent, digits=2){
            if(!percent) return '–'
            return (percent*100).toFixed(digits)+'%'
        },
        getFormatCom(object, transferType, direction){
            const comissionPercent = object.comissions && object.comissions[transferType] ? object.comissions[transferType][direction].percent : 0
            const comissionFix = object.comissions && object.comissions[transferType] ? object.comissions[transferType][direction].fix : 0
            let result = ''
            if(!comissionPercent && !comissionFix) result = '–'
            if(!comissionPercent) result = `${comissionFix}`
            if(!comissionFix) result = this.getFormatPercent(comissionPercent)
            return result
        },
    },
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    },
    mounted() {
        this.LoadCurrencies()
        this.lazyParams = {
            first: 0,
            rows: 10,
            sortField: null,
            sortOrder: null,
            filters: this.filters,
        };
        this.LoadRates()
    },
}
</script>